export const SUBMIT_GET_FORM = 'SUBMIT_GET_FORM';

export const SUBMIT_GET_FIELD_INSERT_DETAILS = 'SUBMIT_GET_FIELD_INSERT_DETAILS';

export const SUBMIT_SET_FORM_FIELDS = 'SUBMIT_SET_FORM_FIELDS'

export const SUBMIT_UPDATE_FORM_FIELD_VALUE = 'SUBMIT_UPDATE_FORM_FIELD_VALUE';

export const SUBMIT_SEND_FORM_SUBMISSION = 'SUBMIT_SEND_FORM_SUBMISSION';

export const SUBMIT_SET_START_DATE = 'SUBMIT_SET_START_DATE';

export const SUBMIT_SET_ERROR = 'SUBMIT_SET_ERROR';
